document.addEventListener("DOMContentLoaded", () => {
  const articles = document.querySelectorAll(".article-grid-card");
  const loadMoreBtn = document.getElementById("load-more");
  const displayingItems = +document.querySelector(
    ".articles-tabs-cards-wrapper[data-show-items]"
  ).dataset.showItems;

  let visibleCount = displayingItems;

  function showArticles() {
    articles.forEach((article, index) => {
      if (index < visibleCount) {
        article.style.display = "block";
      }
    });

    if (visibleCount >= articles.length) {
      loadMoreBtn.style.display = "none";
    }
  }

  showArticles();

  loadMoreBtn?.addEventListener("click", () => {
    visibleCount += displayingItems;
    showArticles();
  });
});
